import React from "react";
import "./ResetPasswordContainer.css";
import {resetPassword, getResetPassword}  from "../../utilities/js/callouts/CalloutFactory";
import getURLParam from "../../utilities/js/ParameterRetrieval";
import InputBox from "../../components/reusable/InputBox";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import BracksetHeader from "components/reusable/BracksetHeader";
import BracksetFooter from "components/reusable/BracksetFooter";
import Constants from "utilities/js/Constants";

const loadingIcon = Constants.ICON_LOADING;

class ResetPasswordContainer extends React.Component {
    
    constructor(props){
        super(props);
        let token = getURLParam('token')
        this.state = {
            username: '',
            email: '',
            token: token,
            password: '',
            verifyPassword: '',
            isLoading: true,
            isError: false,
            errorMessage: "There was a problem resetting your password",
            inputError: null,
            resetSuccessful: false
        };
        
        this.displayContent = this.displayContent.bind(this);
        this.initiatePasswordReset = this.initiatePasswordReset.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.setVerifyPassword = this.setVerifyPassword.bind(this);
        this.navigateToLandingPage = this.navigateToLandingPage.bind(this);
        
    }
    
    componentDidMount(){
        getResetPassword(this.state.token).then(response => {
            this.setState({username: response.username, email: response.email});
        }).catch(error => {
            this.setState({errorMessage: error.message, isError: true})
        }).finally(() => {
            this.setState({isLoading: false});
        })
    }
    
    navigateToLandingPage(){
        navigateToLandingPage({routerNav: this.props.navigate});
    }
    
    setPassword(event){
        this.setState({password: event.target.value});
    }
    setVerifyPassword(event){
        this.setState({verifyPassword: event.target.value});
    }
    
    initiatePasswordReset(){
        if(this.areInputsValid()){
            
            this.setState({isLoading: true});
            resetPassword({token: this.state.token, password: this.state.password}).then(response => {
                this.setState({isError: false, resetSuccessful: true});
            }).catch(error => {
                if(error.code){
                    this.setState({errorMessage: error.message, isError: true})
                }else{
                    this.setState({isError: true});
                }
            }).finally(() => {
                this.setState({isLoading: false});
            });
        }
    }
    


    areInputsValid(){
        let errorDisplay;
        if(!this.state.password || !this.state.verifyPassword){
            errorDisplay = 'Must populate all fields';
        }else if(this.state.password !== this.state.verifyPassword){
            errorDisplay = 'Passwords do not match';
        }
        if(errorDisplay){
            this.setState({inputError: errorDisplay});
            // this.registerInputContainerRef.current.scrollTop = 0;
            return false;
        }

        return true;
    }
    
    displayContent(){
        if(this.state.resetSuccessful){
            return (
                <>
                    <div className="simple-form-result-container">
                        <div className="simple-form-header">Success</div>
                        <div className="simple-form-success-result">The password for the account associated with <b>{this.state.email}</b> has been successfully updated.  Click <a href="/">here</a> to navigate to the home page</div>
                    </div>
                </>
            )
        }else if(this.state.isError){
            return (<>
                <div className="simple-form-result-container">
                    <div className="simple-form-header">Something went wrong...</div>
                    <div className="simple-form-error-result">
                        {this.state.errorMessage}
                        <div className="simple-form-redirect">Click <a href="/">here</a> to navigate to the home page</div>
                    </div>
                </div>
            </>)
        }else{
            return (
            <>
                <div className="">
                    <div className="simple-form-header-container">
                        <div className="simple-form-header">Reset Password</div>
                        <div className="simple-form-sub-header"></div>
                        {this.state.inputError}
                    </div>
                    <div className="input-container">
                        <div className="simple-form-input-label">Password</div>
                        <InputBox uniqueKey="password" name='loginPassword' type="password" placeholder='password' class='login-styled-input' value={this.state.password} valueChangedCallback={this.setPassword}></InputBox>
                    </div>
                    <div className="input-container">
                        <div className="simple-form-input-label">Verify Password</div>
                        <InputBox uniqueKey="verifyPassword" name='verifyPassword' type="password" placeholder='verify password' class='login-styled-input' value={this.state.verifyPassword} valueChangedCallback={this.setVerifyPassword}></InputBox>
                    </div>
                    <div className="simple-form-button-container">
                        <button label='login-button' className='login-button' onClick={this.initiatePasswordReset}>Reset Password</button>
                    </div>
                </div>
                <div className="simple-form-footer">
                    Not interested in resetting your password? <button className="login-toggle-button" onClick={this.navigateToLandingPage}>Return Home</button>
                </div>
            </>
            )
        }
    }
            
    render(){
        let content = (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
        if(!this.state.isLoading){
            content = (<>{this.displayContent()}</>);
        }
        
        return (
            <>
            <div className="brackset-container">
                
                <BracksetHeader hideSearch="true"></BracksetHeader>
                <div className="simple-form">
                    {content}
                </div>
                <BracksetFooter></BracksetFooter>
                {/* <AccountControl ></AccountControl> */}

            </div>
            </>
        )
            
    }
}

export default NavigatorWrapper(ResetPasswordContainer);
    